import React, { useEffect, useState } from "react"
import { Column, Container, Row } from "../../components/Grid"
import HeroHome from "../../components/HeroHome"
import Icon from "../../components/Icon"
import Image from "../../components/Image"
import Layout from "../../components/Layout"
import OutboundLink from "../../components/OutboundLink"
import PageCards from "../../components/PageCards"
import Section from "../../components/Section"
import SEO from "../../components/Seo"
import Subscribe from "../../components/Subscribe"
import Video from "../../components/Video"
import RxBottle from "../../images/theme/img-Rx-bottle.png"
import AboutPharmTeach from "../../images/theme/img-hp-icon-pharm-teach.png"

const IndexPage = ({ data }) => {
  const [hostname, setHostname] = useState("")
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    setLoaded(true)
    setHostname(
      window.location.protocol +
        "//" +
        window.location.hostname +
        (window.location.port ? ":" + window.location.port : "")
    )
  }, [])

  return (
    <Layout>
      <SEO title="Home" />
      {/***************  HERO ***************/}
      <Section className="hero__home">
        <HeroHome
          title="Dose of Knowledge"
          subheading="Programa “Pharmacists Teach”"
          image="img-hp-hero-heart@2x.png"
        />
      </Section>

      {/***************  CALLOUT  ***************/}
      <Section className="callout">
        <Container>
          <Row>
            <Column span={12}>
              <Subscribe
                trigger={
                  <button>
                    <img
                      src={RxBottle}
                      className="rx-bottle"
                      alt="Dose of Knowledge Rx Bottle"
                    />
                    <span>
                      ¡Regístrate hoy para recibir las actualizaciones!
                    </span>{" "}
                    <Icon name="rightarrow" inline />
                  </button>
                }
              />
            </Column>
          </Row>
        </Container>
      </Section>

      <Section>
        <Container>
          <Row className="home-interactive-row">
            <Column span={6} className="pb-1">
              <h2 className="mt-1">
                Piénsalo bien: una experiencia para elegir tu propio camino
              </h2>
              <p>
                Descubre recursos interactivos diseñados para capacitar a
                estudiantes con el fin de que tomen decisiones inteligentes y
                saludables cuando se enfrenten a opciones que prometen una
                salida fácil.
              </p>
              <div className="resource__action">
                <a href="/es/educators/#CYOA">
                  <Icon name="module" inline />
                  Más información
                </a>
              </div>
            </Column>
            <Column span={6}>
              <div style={{ position: "relative" }}>
                <Image filename="CVS-ATS-Title-Card-Spanish.jpg" />
                <Image filename="flag-New-ES.png" className="new-flag" />
              </div>
            </Column>
          </Row>
        </Container>
      </Section>

      {/***************  ABOUT BE VAPE FREE ***************/}
      <Section className="about-program lightgray">
        <Container>
          <Row>
            <Column span={6}>
              <div className="embed-container">
                {" "}
                {loaded && (
                  <Video
                    guidSrc="90c60ac1-1f8c-4f13-b70d-869ec28d7a5b"
                    posterSrc="img-hp-nflpa-adrianna.jpg"
                  />
                )}
              </div>
            </Column>
            <Column span={5}>
              <h2>Acerca del programa</h2>
              <p>
                CVS refuerza su compromiso con la educación de los jóvenes a
                través del programa Pharmacists Teach / Dose of Knowledge (El
                farmacéutico enseña / Una Dosis de Conocimiento), un programa
                gratuito de alcance educativo que, en colaboración con Discovery
                Education, se ha ampliado para beneficiar a estudiantes desde el
                primer ciclo básico hasta el nivel medio superior sobre aspectos
                fundamentales como el uso indebido de sustancias, la seguridad
                con los medicamentos y la salud mental.
              </p>
            </Column>
          </Row>
        </Container>
      </Section>

      <Section>
        <Container>
          <PageCards
            cards={[
              {
                to: "/es/educators/",
                label: "Educadores",
                image: "img-hero-infographic-educators.png",
                description:
                  "Descubra recursos alineados con los estándares curriculares, así como planes de clase y actividades de fácil implementación para iniciar el diálogo con los estudiantes sobre temas como el uso indebido de sustancias, el uso seguro de medicamentos y la salud mental.",
              },
              {
                to: "/es/pharmacists/",
                label: "Farmacéuticos",
                image: "img-hero-infographic-pharmacists.png",
                description:
                  "Comparta su experiencia profesional en el aula mediante recursos diseñados para ayudar a los estudiantes a tomar decisiones saludables y promover el diálogo sobre el uso indebido de sustancias, el uso seguro de medicamentos y la salud mental.",
              },
              {
                to: "/es/students/",
                label: "Estudiantes",
                image: "img-hero-infographic-students.png",
                description:
                  "Descubra recursos interactivos diseñados para capacitar a estudiantes con el fin de que tomen decisiones inteligentes y saludables cuando se enfrenten a la presión de grupo.",
              },
              {
                to: "/es/caregivers/",
                label: "Cuidadores",
                image: "img-hero-infographic-caregivers.png",
                description:
                  "Brinde apoyo a los estudiantes desde casa con recursos y actividades que facilitan el diálogo sobre temas como el uso indebido de sustancias y la salud mental.",
              },
            ]}
          />
        </Container>
      </Section>

      <Section>
        <Container>
          <Row className="home-interactive-row">
            <Column span={6}>
              <div style={{ position: "relative" }}>
                <Image filename="img-home-pharmacy-career-exploration.png" />
              </div>
            </Column>
            <Column span={6} className="pb-1">
              <h2 className="mt-1">Descubrir carreras en farmacéutica</h2>
              <p>
                Descubra el papel fundamental que desempeñan los farmacéuticos
                en la salud y el bienestar de su comunidad mediante la
                evaluación inicial de los pacientes, la aplicación de vacunas e
                información importante sobre medicamentos.
              </p>
              <div className="resource__action">
                <a href="/es/pharmacy-careers">
                  <Icon name="module" inline />
                  Más información
                </a>
              </div>
            </Column>
          </Row>
        </Container>
      </Section>

      {/***************  ABOUT PHARMACISTS TEACH INFO ***************/}
      <Section className="about-pharmacists darkgray-background">
        <Container>
          <Row>
            <Column span={3}>
              <img
                src={AboutPharmTeach}
                className="pharma-teach-placeholder"
                alt="Dose of Knowledge Rx Bottle"
              />
            </Column>
            <Column span={9}>
              <h2>Acerca del programa Pharmacists Teach</h2>
              <p>
                CVS Health creó el programa Pharmacists Teach en 2015 para
                llevar a los farmacéuticos a las aulas para educar a la
                población sobre el uso indebido de sustancias. El programa
                Pharmacists Teach se ha ampliado para incluir{" "}
                <b>Dose of Knowledge</b>, una iniciativa desarrollada en
                colaboración con Discovery Education que proporciona recursos
                alineados con los estándares educativos tanto a docentes como a
                farmacéuticos en todo Estados Unidos. Desde su inicio, el
                programa <b>Pharmacists Teach / Dose of Knowledge</b> (El
                farmacéutico enseña / Una Dosis de Conocimiento) ha tenido un
                impacto positivo en la vida de millones de personas en todo el
                país, capacitando a los estudiantes para tomar decisiones
                saludables que beneficien tanto su bienestar como el de sus
                comunidades.
              </p>
              <OutboundLink to="https://www.cvshealth.com/social-responsibility/corporate-social-responsibility/pharmacists-teach">
                <button className="global__button darkgray">
                  Más información
                </button>
              </OutboundLink>
            </Column>
          </Row>
        </Container>
      </Section>
    </Layout>
  )
}

export const query = graphql`
  query HomePageQueryEs {
    site {
      siteMetadata {
        gaId
      }
    }
  }
`

export default IndexPage
